import { Box, Container, Divider, Grid, Stack, Text } from "@mantine/core";
import React, { useEffect, useRef } from "react";

import GpaReportHeader from "../common/OpaReportHeader";
import OverviewSection from "./sections/OverviewSection";
import StatisticsLegand from "../../comon/StatisticsLegand";
import { useTranslation } from "react-i18next";

export default function OverviewPage(_props) {
  const componentRefs = useRef([]);

  const [uuids, setUuids] = React.useState([]);
  const [patient, setPatient] = React.useState(null);
  const [eye, setEye] = React.useState(null);
  const [type, setType] = React.useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const uuid = params.get("uuid");
    if (uuid && uuid !== "") {
      const ids = uuid.split(",");
      ids.reverse();
      setUuids(ids);
    }
  }, []);

  const addToRefs = (index) => (el) => {
    if (el) {
      componentRefs.current[index] = el;
    }
  };

  function setHeaderInfo(patient, eye, type) {
    setPatient(patient);
    setEye(eye);
    setType(type);
  }

  const divider = <Divider size={"md"} variant="dashed" color="gray.6" />;
  const headerText = (text) => (
    <Text ta="center" fw={600} size={"lg"} c="dimmed">
      {text}
    </Text>
  );

  return (
    <Stack>
      <Container size={"xl"}>
        {new Array(Math.ceil(uuids.length / 3)).fill(0).map((_, index) => {
          return (
            <Box key={`overview-page-${index}`} ref={addToRefs(index)}>
              <Box p={"lg"}>
                {patient && (
                  <GpaReportHeader
                    title={"Overview"}
                    name={patient.name}
                    dob={patient.dob}
                    type={type}
                    uuid={patient.uuid}
                    eye={eye}
                  />
                )}
                <Stack my={"sm"}>
                  <Grid>
                    <Grid.Col span={3}>{headerText(t("grayTone"))}</Grid.Col>
                    <Grid.Col span={3}>{headerText(t("threshold"))}</Grid.Col>
                    <Grid.Col span={3}>{headerText(t("totalDeviation"))}</Grid.Col>
                    <Grid.Col span={3}>{headerText(t("patternDeviation"))}</Grid.Col>
                  </Grid>

                  <OverviewSection
                    uuid={uuids[index * 3]}
                    setHeaderInfo={index * 3 == 0 ? setHeaderInfo : undefined}
                  />
                  {divider}
                  {uuids.length > index * 3 + 1 && (
                    <React.Fragment key={index * 3 + 1}>
                      <OverviewSection
                        uuid={uuids[index * 3 + 1]}
                        setHeaderInfo={index * 3 == 0 ? setHeaderInfo : undefined}
                      />
                      {divider}
                    </React.Fragment>
                  )}

                  {uuids.length > index * 3 + 2 && (
                    <React.Fragment key={index * 3 + 2}>
                      <OverviewSection
                        uuid={uuids[index * 3 + 2]}
                        setHeaderInfo={index * 3 == 0 ? setHeaderInfo : undefined}
                      />
                      {divider}
                    </React.Fragment>
                  )}
                </Stack>
                <StatisticsLegand cols={4} />
                <Divider size={"md"} color="gray.6" my={"lg"} />
              </Box>
            </Box>
          );
        })}
      </Container>
    </Stack>
  );
}
